<template>
  <div class="load-more-articles" v-view.once="viewHandler">
    <ul class="article-grid" :class="{'article-grid--transparent': transparent}">
      <li v-for="(article, i) in loadList" :key="i"  v-tag:useractionevent='{ name:"select_article",click_area:"content",articlename:"@article.title"}'>
        <a
          :href="article.url"
          class="card article-card"
          :id="`article-card--${i}`"
        >
          <div class="article-card__image">
            <img
              class="lazyload "
              :alt="article.imgAlt"
              height="179"
              :data-src="article.imgLazy"
              width="146"
            />
          </div>
          <div class="article-card__content">
            <div class="article-card__title" v-ellipsis="50">
              {{ article.title }}
            </div>
            <div class="article-card__text" v-ellipsis="50">
              {{ article.text }}
            </div>
            <div class="article-card__datetime" v-if="hideDate" />
            <div class="article-card__datetime" v-if="!hideDate">
              {{ article.datetime }}
            </div>
          </div>
          <div class="debug-info">
            {{ article.debug_info }}
          </div>
        </a>
      </li>
    </ul>
    <div
      :class="[
        'load-more-articles__loading',
        { 'load-more-articles__loading--show': loading },
      ]"
      :aria-live="hasMoreArticlesToLoad ? 'polite' : 'off'"
    >
      <div v-if="loading">
        <span class="is-sr-only">{{ loadingStateLabel }}</span>
        <slot />
      </div>
    </div>
    <div class="load-more-articles__cta">
      <button
        @click="loadMoreArticles"
        v-if="hasMoreArticlesToLoad"
        class="btn btn--secondary"
        :aria-label="loadMoreScreenReaderText"
      >
        {{ loadMoreCtaLabel }}
      </button>
    </div>
  </div>
</template>

<script>
  import { ellipsis } from "@Foundation/directives/ellipsis/ellipsis";
  import { srcset } from "@Foundation/directives/srcset/srcset";
  import { eventBus } from "@Foundation/eventbus/eventbus";

  export default {
    name: "load-more-articles",
    directives: {
      ellipsis,
      srcset,
    },
    props: {
      apiUrl: {
        type: String,
        required: true,
      },
      loadMoreCtaLabel: {
        type: String,
        required: false,
        default: "Load More",
      },
      loadingStateLabel: {
        type: String,
        required: false,
        default: "Loading more results",
      },
      loadMoreScreenReaderText: {
        type: String,
        required: false,
        default: "Load more articles",
      },
      hideDate: {
        type: Boolean,
        required: false,
        default: false,
      },
      requestOnPageload: {
        type: Boolean,
        required: false,
        default: false,
      },
      moreArticlesFirstLoad: {
        type: Boolean,
        default: true,
      },
      transparent: {
        type: Boolean,
        required: false,
        default: false,
      }
    },
    data() {
      return {
        baseUrl: null,
        url: null,
        loadList: [],
        hasMoreArticlesToLoad: true,
        isTablet: window.matchMedia("(min-width: 768px) and (max-width: 1024px)")
          .matches,
        loadedFirstTime: false,
        loading: false,
        firstLoadedCard: null,
        filters: [],
        sort: "",
      };
    },
    created() {
      if (!this.moreArticlesFirstLoad) {
        this.hasMoreArticlesToLoad = false;
      }
      this.baseUrl = this.apiUrl;
      this.url = this.apiUrl;
      eventBus.$on("search-filters-change", (filtersAndSort) => {
        this.loadList = [];
        this.applyFiltersToUrl(filtersAndSort);
        this.hasMoreArticlesToLoad = false;
      });
      eventBus.$on("articles-loaded", (payload) => {
        this.url = payload.newUrl;
        this.hasMoreArticlesToLoad = payload.hasMore;
      });
    },
    methods: {
      loadMoreArticles() {
        this.loading = true;
        const parseJSON = (response) => response.json();
        fetch(this.url)
          .then(parseJSON)
          .then((data) => {
            this.url = data.newUrl;
            if (data.articles) {
              this.loadList = this.loadList.concat(data.articles);
              this.firstLoadedCard = data.articles[0].url;
              this.hasMoreArticlesToLoad = data.hasMore;

              this.$nextTick(() => {
                this.placeFirstItemOnBlockForTablet();
                this.focusOnFirstLoadedCard();
              });
            }
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
            console.error("Could not load articles", error); // eslint-disable-line no-console
          });
          let eventDetails = pageData.pageCategory.toLowerCase();
          if(eventDetails == "home page"){
              eventDetails="homepage";
          }
          const load_more = {
                event_name:"button_click",
                cta_name:"load more",
                event_detail:eventDetails
          };
          window.dataLayer.push(load_more);
      },
      focusOnFirstLoadedCard() {
        const card = document.querySelector(`a[href="${this.firstLoadedCard}"`);

        if (card) {
          card.focus();
        }
      },
      viewHandler(e) {
        if (e.type === "enter" && this.requestOnPageload) {
          this.loadMoreArticles();
        }
      },
      placeFirstItemOnBlockForTablet() {
        if (this.isTablet && !this.loadedFirstTime) {
          const articleGridContainer = document.querySelector(".article-grid");
          const first = document.querySelector("#article-card--0").parentElement;

          if (first) {
            articleGridContainer.append(first);
          }
          this.loadedFirstTime = true;
        }
      },
      applyFiltersToUrl(filtersAndSort) {
        this.filters = filtersAndSort.filters;
        this.sort = filtersAndSort.sort;
        this.url = this.baseUrl;

        if (this.sort) {
          this.url = this.url.concat(`&sort=${this.sort}`);
        }
        if (this.filters.length > 0) {
          this.filters.forEach((filter) => {
            this.url = this.url.concat(`&${filter.key}=${filter.value}`);
          });
        }
      },
    },
  };
</script>

<style src="./LoadMoreArticles.scss" lang="scss">
